import React from 'react'

import './option.scss'

const Option = props => {
	const { data, innerProps, innerRef } = props

	const cN = props.isFocused
		? 'c-select-option c-select-option--focused'
		: 'c-select-option'

	return (
		<div ref={innerRef} {...innerProps} className={cN}>
			<div className="c-select-option__title">{data.label}</div>
			<div className="c-select-option__description">
				{data.description}
			</div>
		</div>
	)
}

export default Option
